import {useQuery, gql} from '@apollo/client'

const clientDetails = gql`
  query clientDetails($clientId: Numeric) {
    clientDetails(clientId: $clientId) {
      CLIENT_NAME
      GROUP_ID
    }
  }
`

export function useGetClientName(clientId) {
  const {
    data: clientNameData,
    loading: loadingClientName,
    error: errorClientName
  } = useQuery(clientDetails, {
    context: {clientName: 'adminPanel'},
    variables: {clientId},
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all'
  })
  return {clientNameData, loadingClientName, errorClientName}
}
